export const LANGUAGE = 'locale/LANGUAGE';
export const DIRECTION = 'locale/DIRECTION';
export const INIT_LANGUAGE = 'locale/INIT_LANGUAGE';
export const AVAILABLE_LANGUAGES = 'local/AVAILABLE_LANGUAGES';
export const TITLE = 'layout/TITLE';
export const PAGETITLE = 'layout/PAGETITLE';
export const SIDENAV_VISIBILITY = 'layout/SIDENAV_VISIBILITY';
export const SIDENAV_COLLAPSED = 'layout/SIDENAV_COLLAPSED';
export const SIDENAV_TOGGLE_COLLAPSED = 'layout/SIDENAV_TOGGLE_COLLAPSED';
export const SET_SIDEBAR = 'layout/SET_SIDEBAR';
export const LOADING = 'layout/LOADING';
export const ACTIVE_SIDEBAR = 'layout/ACTIVE_SIDEBAR';
export const UNSET_SIDEBAR = 'layout/UNSET_SIDEBAR';
export const HAS_INTERNAL_NAV = 'layout/HAS_INTERNAL_NAV';

// Publisher

export const CONTRACT = 'publisher/CONTRACT';
export const MEMBERSHIP = 'publisher/MEMBERSHIP';
export const APP_CATEGORIES = 'categories/APP_CATEGORIES';

// APPS Contants

export const APPS = 'apps/APPS';
export const PUBLISHED_APPS = 'apps/PUBLISHED_APPS';
export const DRAFT_APP = 'apps/DRAFT_APP';
export const UPDATE_DRAFT_APP = 'apps/UPDATE_DRAFT_APP';
export const CHANGE_DRAFT_APP_STATE = 'apps/CHANGE_DRAFT_APP_STATE';

// APP constants

export const APP_DETAILS = 'app/APP_DETAILS';
export const APP_PRICE = 'app/APP_PRICE';
export const APP_AUTHOR = 'app/APP_AUTHOR';
export const APP_PRICE_PENDING_STATUS = 'app/APP_PRICE_PENDING_STATUS';
export const UNSET_APP = 'app/UNSET';
export const TAX_RATE = 'app/TAX_RATE';
export const UPDATE_APP_DETAILS = 'app/UPDATE_APP_DETAILS';
export const DELETE_APP_COVER = 'app/DELETE_APP_COVER';
export const APP_CHARTS_CONFIG = 'app/APP_CHARTS_CONFIG';

// App screenshots

export const SCREENSHOTS = 'app/SCREENSHOTS';
export const PROMO_SCREENSHOTS = 'app/PROMO_SCREENSHOTS';
export const UPDATE_SCREENSHOTS = 'app/UPDATE_SCREENSHOTS';
export const UPDATE_PROMO_SCREENSHOTS = 'app/UPDATE_PROMO_SCREENSHOTS';

// App releases

export const RELEASES = 'app/RELEASES';
export const REPLACE_RELEASE = 'app/REPLACE_RELEASE';
export const ADD_RELEASE = 'app/ADD_RELEASE';
export const ADD_PACKAGE_TO_RELEASE = 'app/ADD_PACKAGE_TO_RELEASE';
export const UPDATE_RELEASE = 'app/UPDATE_RELEASE';
export const PUBLISH_RELEASE = 'app/PUBLISH_RELEASE';
export const REMOVE_RELEASE_PACKAGE = 'app/REMOVE_RELEASE_PACKAGE';
export const CREATE_NEW_RELEASE = 'app/CREATE_NEW_RELEASE';
export const UNCOMMITTED_RELEASE = 'app/UNCOMMITTED_RELEASE';
export const UPDATE_UNCOMMITTED_RELEASE = 'app/UPDATE_UNCOMMITTED_RELEASE';
export const UNCOMMITTED_RELEASE_REPLACE_PACKAGE =
  'app/UNCOMMITTED_RELEASE_REPLACE_PACKAGE';
export const DELETE_UNCOMMITTED_RELEASE = 'app/DELETE_UNCOMMITTED_RELEASE';
export const COMMIT_RELEASE = 'app/COMMIT_RELEASE';
export const CPU_ARCHITECTURES = 'app/CPU_ARCHITECTURES';
export const IS_FETCHING_CPU_ARCHITECTURES =
  'app/IS_FETCHING_CPU_ARCHITECTURES';
export const GROUP_RELEASE = 'app/GROUP_RELEASE';
export const CREATE_GROUP_RELEASE = 'app/CREATE_GROUP_RELEASE';
export const GROUP_RELEASE_BY_ID = 'app/GROUP_RELEASE_BY_ID';
export const UPDATE_GROUP_RELEASE = 'app/UPDATE_GROUP_RELEASE';
export const REMOVE_GROUP_RELEASE = 'app/REMOVE_GROUP_RELEASE';
export const GET_GROUP_MEMBERS = 'app/GET_GROUP_MEMBERS';
export const REMOVE_GROUP_MEMBER = 'app/REMOVE_GROUP_MEMBER';
export const GROUP_RELEASE_MEMBER = 'app/GROUP_RELEASE_MEMBER';
export const ALPHA_GROUP = 'app/ALPHA_GROUP';
export const BETA_GROUP = 'app/BETA_GROUP';

// Settlement

export const SETTLEMENT_REPORTS = 'settlement/REPORTS';

// Tax invoices

export const TAX_INVOICE_HISTORY = 'settlement/TAX_INVOICES';
export const SETTLEMENT_MISC_TRANSACTIONS = 'settlement/MISC_TRANSACTIONS';

// vuex modules

export const RESET = 'module/RESET';

// Advertisements

export const CHANGE_BIDS_STATUS = 'ads/CHANGE_BID_STATUS';
export const CHANGE_SINGLE_BID_STATUS = 'ads/CHANGE_SINGLE_BID_STATUS';

export const CAMPAIGN_BIDS = 'ads/CAMPAIGN_BIDS';
export const CAMPAIGN_BIDS_META_DATA = 'ads/CAMPAIGN_BIDS_META_DATA';
export const CHANGE_BID_MATCHING_TYPE = 'ads/CHANGE_BID_MATCHING_TYPE';
export const SELECTED_CAMPAIGN_BIDS = 'ads/SELECTED_CAMPAIGN_BIDS';
export const DELETE_CAMPAIGN_BIDS = 'ads/DELETE_CAMPAIGN_BIDS';
export const ADD_CAMPAIGN_BID = 'ads/ADD_CAMPAIGN_BID';
export const EDIT_CAMPAIGN_BIDS = 'ads/EDIT_CAMPAIGN_BIDS';
export const EDIT_SINGLE_CAMPAIGN_BID = 'ads/EDIT_SINGLE_CAMPAIGN_BID';
export const CAMPAIGN_ID = 'ads/CAMPAIGN_ID';

// Mail service of the advertisement

export const MAIL_SERVICE = 'ads/MAIL_SERVICE';
export const ADD_MAIL_SERVICE = 'ads/ADD_MAIL_SERVICE';
export const DELETE_MAIL_SERVICE = 'ads/DELETE_MAIL_SERVICE';
export const EDIT_MAIL_SERVICE = 'ads/EDIT_MAIL_SERVICE';
export const EDIT_STATUS_MAIL_SERVICE = 'ads/EDIT_STATUS_MAIL_SERVICE';

// Bulk Import of advertisement

export const BULK_IMPORT_BIDS = 'ads/BULK_IMPORT_BIDS';
export const BULK_IMPORT_BIDS_SELECTED_KEYWORDS =
  'ads/BULK_IMPORT_BIDS_SELECTED_KEYWORDS';
export const BULK_IMPORT_LOAD_BIDS = 'ads/BULK_IMPORT_LOAD_BIDS';
export const BULK_IMPORT_EDIT_SELECTED_BIDS =
  'ads/BULK_IMPORT_EDIT_SELECTED_BIDS';
export const BULK_IMPORT_DELETE_SELECTED_BIDS =
  'ads/BULK_IMPORT_DELETE_SELECTED_BIDS';
export const BULK_IMPORT_DELETE_BID = 'ads/BULK_IMPORT_DELETE_BID';
export const BULK_IMPORT_RESET = 'ads/BULK_IMPORT_RESET';

// Search Ads Campaign Hints
export const SEARCH_ADS_CAMPAIGN_HINTS = 'search-ads/SEARCH_ADS_CAMPAIGN_HINTS';
export const SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT =
  'search-ads/SEARCH_ADS_CAMPAIGN_HINTS_SET_KEYWORDS_HINT';
export const SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT =
  'search-ads/SEARCH_ADS_CAMPAIGN_HINTS_SET_CPI_LIMIT';
export const SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT =
  'search-ads/SEARCH_ADS_CAMPAIGN_HINTS_SET_BUDGET_HINT';
export const SEARCH_ADS_RESET_HINTS = 'search-ads/SEARCH_ADS_RESET_HINTS';

// Ad Contract
export const AD_CONTRACT = 'advertisement/CONTRACT';
export const ACCEPT_AD_CONTRACT = 'advertisement/ACCEPT_CONTRACT';
export const HAS_SEEN_CONTRACT = 'advertisement/HAS_SEEN_CONTRACT';

// modal plugin
export * from '@/plugins/modal/storeTypes';

// Agents
export const AGENT_PREFERENCES = 'agents/AGENT_PREFERENCES';
export const GET_AGENT_PREFERENCE = 'agents/GET_AGENT_PREFERENCE';
export const CHANGE_AGENT_PREFERENCE = 'agents/CHANGE_AGENT_PREFERENCE';

// Feature Flags
export const SHOW_ADS = 'featureFlags/SHOW_ADS';
export const SET_FEATURE_FLAGS = 'featureFlags/SET_FEATURE_FLAGS';
export const FETCH_FEATURE_FLAGS = 'featureFlags/FETCH_FEATURE_FLAGS';

export const AGENT_CONFIG = 'agents/AGENT_CONFIG';
export const GET_AGENT_CONFIG = 'agents/GET_AGENT_CONFIG';